/**
 * Utilitaire pour vider complètement le cache de l'application
 * Simule Cmd+Shift+Delete mais uniquement pour notre app
 *
 * ⚠️ **Note** : Cette librairie définit ses propres constantes pour éviter les dépendances
 * vers d'autres librairies qui utilisent des alias frontend (`@/`).
 */

/**
 * Clés localStorage à préserver lors du nettoyage
 * (préférences utilisateur qui doivent survivre aux changements de session)
 */
const PRESERVED_STORAGE_KEYS = [
  // Thème
  'theme',
  'sphere-theme',
  'vite-ui-theme',
  'dark-mode',
  'color-scheme',
  // Contexte établissement (doit persister pendant la session)
  'sphere:activeEstablishmentId',
  'sphere:activeAcademicYear',
  'admin-context-storage',
] as const

/**
 * Clé de flag pour détecter un changement de session Keycloak
 */
const SESSION_CHANGED_FLAG = 'keycloak-session-changed'

/**
 * Vide toutes les données persistées de l'application
 * - localStorage (sauf les préférences utilisateur comme le thème)
 * - sessionStorage
 * - Cache des stores Zustand
 */
export function clearAppCache() {
  console.log("🧹 Nettoyage complet du cache de l'application...")

  // 1. Lister toutes les clés à supprimer du localStorage
  const keysToRemove: string[] = []

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key) {
      // Vérifier si la clé doit être préservée
      const shouldPreserve = PRESERVED_STORAGE_KEYS.some(preserved =>
        key.toLowerCase().includes(preserved.toLowerCase())
      )

      if (!shouldPreserve) {
        keysToRemove.push(key)
      }
    }
  }

  // Supprimer les clés identifiées
  keysToRemove.forEach(key => {
    localStorage.removeItem(key)
    console.log(`  ✓ Supprimé: ${key}`)
  })

  // 2. Vider complètement le sessionStorage
  sessionStorage.clear()
  console.log('  ✓ sessionStorage vidé')

  console.log('✅ Cache nettoyé avec succès')
}

/**
 * Nettoie le cache au démarrage de l'application
 * À appeler AVANT l'initialisation des stores Zustand
 */
export function clearCacheOnStartup() {
  // Vérifier s'il faut nettoyer au démarrage
  // On nettoie si on détecte un changement de session Keycloak
  const shouldClear = sessionStorage.getItem(SESSION_CHANGED_FLAG)

  if (shouldClear === 'true') {
    console.log('🔄 Changement de session détecté - Nettoyage du cache...')
    clearAppCache()
    sessionStorage.removeItem(SESSION_CHANGED_FLAG)
  }
}

/**
 * Vide uniquement les données d'authentification
 */
export function clearAuthCache() {
  console.log("🔐 Nettoyage du cache d'authentification...")

  // Clés Zustand pour l'auth
  localStorage.removeItem('sphere-auth')

  // Tokens
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('token')

  console.log("✅ Cache d'authentification nettoyé")
}
